import { render, staticRenderFns } from "./AgenteaduanaGrid.vue?vue&type=template&id=06cf22c8"
import script from "./AgenteaduanaGrid.vue?vue&type=script&lang=js"
export * from "./AgenteaduanaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports